import styled from "styled-components";

export const ResponsiveContainer = styled.div`
  width: 100%;
  border-radius: 0.375rem;
  max-width: 1280px;
  min-height: 100vh;
  position: relative;
  margin: 0 auto;
  overflow: hidden;
  @media (max-width: 1100px) {
    min-height: calc(100dvh - 200px);
  }
`

export const ErrorContainer = styled.div`
  padding: 20px;
  color: red;
  text-align: center;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`